import { eventBus } from '../core/EventBus';
import { Game } from '../core/Game';

export class EventManager {
  constructor(
    private game: Game
  ) {
    this.setupSettingsEvents();
  }

  private setupSettingsEvents(): void {
    eventBus.on('settings:timeSpeed', (speed: number) => {
      this.game.settings.timeSpeed = speed;
    });
  }
}
